
export const formatCurrency = (amount: number, currency: string = 'GBP'): string => {
  // Handle GBP specifically to show £ symbol
  if (currency.toUpperCase() === 'GBP') {
    return `£${amount.toFixed(2)}`;
  }
  
  // For other currencies, use the standard format
  return `${currency.toUpperCase()} ${amount.toFixed(2)}`;
};
